<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Revisar Análise Financeira do Cliente
                </h4>        
            </div>
            <div class="modal-body">
                <ng-template [ngIf]="isLoading">
                    <p class="my-2">
                        <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando
                    </p>
                </ng-template>
                
                <sgt-cliente-analise-financeira-form
                    #form
                    [cliente]="cliente">
                </sgt-cliente-analise-financeira-form>
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="close()" [disabled]="isLoading">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" #btnRevisar (click)="revisar()" [disabled]="isLoading">
                    <i class="far fa-edit"></i> Revisar
                </button>                  
            </div>            
        </div>
    </div>
</div>